import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import GoogleMap from 'google-map-react';
import utils, { constants } from '@utils';
import { MapMarker } from '@components/common';

function _getMapOptions(maps) {
	return {
		zoomControl        : true,
		styles             : constants.GOOGLE_MAP_SETTINGS.styles,
		mapTypeControl     : true,
		zoomControlOptions : {
			position : maps.ControlPosition.LEFT_BOTTOM,
			style    : maps.ZoomControlStyle.SMALL,
		},
	};
}

class MapView extends Component {
	shouldComponentUpdate = ({
		center, zoom, jobs, isActive,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(center, lastProps.center)
			|| !isEqual(zoom, lastProps.zoom)
			|| !isEqual(jobs, lastProps.jobs)
			|| !isEqual(isActive, lastProps.isActive)
		);
	}

	getDateFormatted = (date, format = 'MMMM Do YYYY, h:mm a') => {
		const { timeZoneId } = this.props;
		return utils.parseUTCDateToTimeZone(date, timeZoneId).format(format);
	}

	render() {
		const {
			jobs,
			zoom,
			center,
		} = this.props;

		return (
			<div className="map">
				<GoogleMap
					zoom={zoom}
					center={center}
					bootstrapURLKeys={{ key : constants.GOOGLE_MAP_SETTINGS.key }}
					options={_getMapOptions}
				>
					<For
						index="jobIndex"
						each="job"
						of={jobs}
					>
						<MapMarker
							key={`job_${jobIndex}`}
							type={`job-marker ${job.color}`}
							lat={job.lat}
							lng={job.lng}
							title={job.title}
							message={job.message}
						/>
					</For>
				</GoogleMap>
			</div>
		);
	}
}

MapView.propTypes = {
	isActive   : PropTypes.bool,
	timeZoneId : PropTypes.string.isRequired,
	jobs       : PropTypes.array,
	zoom       : PropTypes.number,
	center     : PropTypes.shape({
		lat : PropTypes.number,
		lng : PropTypes.number,
	}),
};

MapView.defaultProps = {
	isActive : false,
	jobs     : [],
	zoom     : 4,
	center   : constants.GOOGLE_MAP_SETTINGS.defaultCenter,
};

export default MapView;
